import { apiFetch, parseApiResponse } from '../../utils/apiClient';

export const getLaborProfiles = async () =>
  parseApiResponse(await apiFetch('/api/quote-labor-profiles'));

export const createLaborProfile = async (payload) =>
  parseApiResponse(await apiFetch('/api/quote-labor-profiles', {
    method: 'POST',
    body: JSON.stringify(payload),
  }));

export const addLaborProfileRate = async (profileId, payload) =>
  parseApiResponse(await apiFetch(`/api/quote-labor-profiles/${profileId}/rates`, {
    method: 'POST',
    body: JSON.stringify(payload),
  }));

export const setLaborProfileActive = async (profileId, isActive) =>
  parseApiResponse(await apiFetch(`/api/quote-labor-profiles/${profileId}/active`, {
    method: 'PATCH',
    body: JSON.stringify({ isActive }),
  }));
